import React from 'react';
import { AppBar, Toolbar, Box } from '@mui/material';
const logo = require('~/_svgs/product_logo_long.svg').default;

const SignInContainer: React.FC = ({ children }) => {
  return (
    <div>
      <AppBar>
        <Toolbar>
          <img src={logo} alt="Workforce Forms" />
        </Toolbar>
      </AppBar>
      <Toolbar />
      <Box sx={{
        width: '990px',    
        maxWidth: '100%',
        position: 'absolute',
        top: '12rem',
        left: 0,
        right: 0,
        margin: 'auto',
        padding: '0 1rem',
        boxSizing: 'border-box',
      }}>
        {children}
      </Box>
    </div>
  );
};

export default SignInContainer;
